<template>
  <v-card>
    <v-toolbar dense>
      <!--      <v-btn @click="exitGallery" class="mr-2" v-if="selectedGallery !== null">-->
      <!--        Exit Gallery-->
      <!--        <v-icon right>mdi-arrow-left</v-icon>-->
      <!--      </v-btn>-->
      <v-btn icon class="mr-1" v-on:click="gridViewMedia = true">
        <v-icon>mdi-view-grid</v-icon>
      </v-btn>
      <v-btn icon class="mr-1" v-on:click="gridViewMedia = false">
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
      <!-- <v-btn
        icon
        class="hidden-xs-only"
        @click="createNewGallery()"
        v-if="$store.state.MediaStore.selectedGallery == null"
      >
        <v-icon>mdi-folder-plus-outline</v-icon>
      </v-btn> -->

      <!-- <v-col cols="6" sm="2">
        <v-select
          v-if="false"
          class="mt-7"
          dense
          :items="$store.state.MediaStore.mediaTypes"
          label="Select file type"
          item-text="name"
          item-value="typeId"
          solo
        ></v-select>
      </v-col> -->
      <!-- <v-btn v-if="false" @click="openUploadDialog" class="hidden-xs-only mr-2">
        File upload
        <v-icon right>mdi-file-plus-outline</v-icon>
      </v-btn> -->
      <v-btn
        small
        @click="openMediaItemDialog"
        class="mr-2"
        :disabled="checkedMedia.length > 0"
      >
        Add media
        <v-icon right>mdi-file-plus-outline</v-icon>
      </v-btn>
      <v-btn
        v-if="isBuildingMediaContext"
        small
        @click="addCrossSection"
        class="mr-2"
        :disabled="checkedMedia.length > 0"
      >
        Add cross section
        <v-icon right>mdi-layers-outline</v-icon>
      </v-btn>
      <v-btn
        @click="deleteMediaGroupDialog"
        v-if="checkedMedia.length > 0"
        small
        class="mr-2"
      >
        Delete media
        <v-icon right>mdi-delete-forever</v-icon>
      </v-btn>
      <v-btn
        :disabled="checkSelectedImages"
        small
        @click="setTitleImage"
        class="mr-2"
      >
        Set title image
        <v-icon right>mdi-file-image</v-icon>
      </v-btn>
      <v-fade-transition>
        <span
          v-if="poiGalleryDirty"
          class="caption amber--text d-flex align-center mr-2"
        >
          <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon
          >Unsaved gallery changes
        </span>
      </v-fade-transition>
      <v-btn
        v-if="poiGalleryDirty"
        text
        small
        class="mr-1"
        :disabled="poiGallerySaving"
        @click="discardGallery"
        >Discard</v-btn
      >
      <v-btn
        v-if="poiGalleryDirty"
        color="blue darken-1"
        small
        class="mr-2"
        :loading="poiGallerySaving"
        @click="saveGallery"
        >Save</v-btn
      >
      <v-spacer></v-spacer>
      <v-select
        v-model="filterLangId"
        :items="supportedLangs"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        item-value="id"
        outlined
        dense
        style="max-width: 200px"
        class="mx-2 my-0"
        hide-details="auto"
        label="Language"
      ></v-select>
      <v-text-field
        :hide-details="true"
        outlined
        clearable
        prepend-icon="mdi-magnify"
        v-model="searchKeyword"
        dense
        label="Search"
        style="max-width: 200px"
      >
      </v-text-field>
    </v-toolbar>
    <v-card
      v-if="gridViewMedia"
      style="height: calc(100vh - 275px);"
      class="overflow-auto"
    >
      <v-card-text>
        <v-item-group multiple class="d-flex flex-row flex-wrap">
          <v-item
            v-if="showGhost('title-media-item')"
            class="ma-2"
            key="title-ghost"
          >
            <media-card-poi-title-ghost
              @add="openMediaItemDialog('title-ghost')"
              :langId="getActiveLang"
              :gridView="gridViewMedia"
            />
          </v-item>

          <v-item
            v-if="showGhost('description-media-item')"
            class="ma-2"
            key="description-ghost"
          >
            <media-card-description-ghost
              @add="openMediaItemDialog('description-ghost')"
              :langId="getActiveLang"
              :gridView="gridViewMedia"
            />
          </v-item>

          <v-item
            v-if="showGhost('title-image-media-item')"
            class="ma-2"
            key="image-ghost"
          >
            <media-card-image-ghost
              @add="openMediaItemDialog('image-ghost')"
              :langId="getActiveLang"
              :gridView="gridViewMedia"
            />
          </v-item>

          <v-item
            class="ma-2"
            v-for="m in regularMedia"
            :key="m.updatedAt + '_' + m.id"
          >
            <!--              <v-item v-slot="{ active, toggle }">-->
            <media-card-multi
              :checked="isCheckedMedia(m.id)"
              :is-grid-view="gridViewMedia"
              :media="m"
              @edit="onEdit($event)"
              @deleted="onDeleted($event, m)"
              @changeChecked="changeChecked(m.id, $event)"
            ></media-card-multi>
            <!--              </v-item>-->
          </v-item>
          <v-card
            v-show="infiniteScrollDummyVisible"
            v-intersect="{
              handler: onIntersect,
              options: {
                threshold: [0.5]
              }
            }"
            key="dummy"
            ><div></div>
          </v-card>
        </v-item-group>
        <template v-if="mediaContext === 'poi' && poiGalleryImagesLocal.length">
          <v-divider class="my-4"></v-divider>
          <div class="d-flex align-center mb-2">
            <div class="text-subtitle-1">Gallery</div>
            <v-fade-transition>
              <span
                v-if="isDraggingGallery"
                class="caption ml-3 blue--text text--lighten-2 d-flex align-center"
              >
                <v-icon x-small color="blue lighten-2" class="mr-1"
                  >mdi-swap-horizontal</v-icon
                >Drag to reorder
              </span>
            </v-fade-transition>
          </div>
          <draggable
            :list="poiGalleryImagesLocal"
            handle=".gallery-drag-handle"
            class="d-flex flex-row flex-wrap"
            ghost-class="gallery-drag-ghost"
            :disabled="poiGallerySaving"
            @start="isDraggingGallery = true"
            @end="onGalleryDragEnd"
          >
            <div
              v-for="m in poiGalleryImagesLocal"
              :key="'gallery-' + m.id"
              class="ma-2"
            >
              <media-card-multi
                :checked="isCheckedMedia(m.id)"
                :is-grid-view="true"
                :media="m"
                orderable
                :orderControlsDisabled="poiGallerySaving"
                @edit="onEdit($event)"
                @deleted="onDeleted($event, m)"
                @changeChecked="changeChecked(m.id, $event)"
                @orderChange="onGalleryIndexCommit(m, $event)"
              ></media-card-multi>
            </div>
          </draggable>
        </template>
        <template v-if="showCrossSections">
          <v-divider class="my-4"></v-divider>
          <div class="text-subtitle-1 mb-2">Cross Sections</div>
          <div class="d-flex flex-row flex-wrap">
            <div
              v-for="m in crossSectionMedia"
              :key="'cross-section-' + m.updatedAt + '_' + m.id"
              class="ma-2"
            >
              <div class="text-caption text-center mb-1">
                Floor {{ m.mediaData.floorIndex }}
              </div>
              <media-card-multi
                :checked="isCheckedMedia(m.id)"
                :is-grid-view="true"
                :media="m"
                @edit="onEdit($event)"
                @deleted="onDeleted($event, m)"
                @changeChecked="changeChecked(m.id, $event)"
              ></media-card-multi>
            </div>
          </div>
        </template>
      </v-card-text>
    </v-card>
    <v-card
      style="height: calc(100vh - 275px);"
      class="overflow-auto pa-4"
      v-if="!gridViewMedia"
    >
      <!--      <div v-for="g in $store.state.MediaStore.galleries" :key="g.id">-->
      <!--        <gallery-card :gridView="gridViewMedia" :gallery="g"></gallery-card>-->
      <!--      </div>-->
      <div class="mb-2" v-if="showGhost('title-media-item')">
        <media-card-poi-title-ghost
          @add="openMediaItemDialog('title-ghost')"
          :langId="getActiveLang"
          :gridView="gridViewMedia"
        />
      </div>
      <div class="mb-2" v-if="showGhost('description-media-item')">
        <media-card-description-ghost
          @add="openMediaItemDialog('description-ghost')"
          :langId="getActiveLang"
          :gridView="gridViewMedia"
        />
      </div>
      <div v-if="showGhost('title-image-media-item')">
        <media-card-image-ghost
          @add="openMediaItemDialog('image-ghost')"
          :langId="getActiveLang"
          :gridView="gridViewMedia"
        />
      </div>
      <div v-for="m in regularMedia" :key="m.updatedAt + m.id" class="mb-2">
        <media-card-multi
          :is-grid-view="gridViewMedia"
          :media="m"
          :checked="isCheckedMedia(m.id)"
          :showCheckbox="true"
          :hideActions="checkedMedia.length > 0"
          @changeChecked="changeChecked(m.id, $event)"
          @edit="onEdit($event)"
          @deleted="onDeleted($event)"
        ></media-card-multi>
      </div>
      <v-card
        v-show="infiniteScrollDummyVisible"
        v-intersect="{
          handler: onIntersect,
          options: {
            threshold: [0.5]
          }
        }"
        key="dummy"
        ><div></div>
      </v-card>
      <template v-if="mediaContext === 'poi' && poiGalleryImagesLocal.length">
        <v-divider class="my-4"></v-divider>
        <div class="d-flex align-center mb-2">
          <div class="text-subtitle-1">Gallery</div>
          <v-fade-transition>
            <span
              v-if="isDraggingGallery"
              class="caption ml-3 blue--text text--lighten-2 d-flex align-center"
            >
              <v-icon x-small color="blue lighten-2" class="mr-1"
                >mdi-swap-vertical</v-icon
              >Drag to reorder
            </span>
          </v-fade-transition>
        </div>
        <draggable
          :list="poiGalleryImagesLocal"
          handle=".gallery-drag-handle"
          ghost-class="gallery-drag-ghost"
          :disabled="poiGallerySaving"
          @start="isDraggingGallery = true"
          @end="onGalleryDragEnd"
        >
          <div
            v-for="m in poiGalleryImagesLocal"
            :key="'gallery-' + m.id"
            class="mb-2"
          >
            <media-card-multi
              :is-grid-view="gridViewMedia"
              :media="m"
              :checked="isCheckedMedia(m.id)"
              :showCheckbox="true"
              :hideActions="checkedMedia.length > 0"
              orderable
              :orderControlsDisabled="poiGallerySaving"
              @changeChecked="changeChecked(m.id, $event)"
              @edit="onEdit($event)"
              @deleted="onDeleted($event, m)"
              @orderChange="onGalleryIndexCommit(m, $event)"
            ></media-card-multi>
          </div>
        </draggable>
      </template>
      <template v-if="showCrossSections">
        <v-divider class="my-4"></v-divider>
        <div class="text-subtitle-1 mb-2">Cross Sections</div>
        <div
          v-for="m in crossSectionMedia"
          :key="'cross-section-' + m.updatedAt + '_' + m.id"
          class="mb-2"
        >
          <div class="text-caption mb-1">
            Floor {{ m.mediaData.floorIndex }}
          </div>
          <media-card-multi
            :is-grid-view="gridViewMedia"
            :media="m"
            :checked="isCheckedMedia(m.id)"
            :showCheckbox="true"
            :hideActions="checkedMedia.length > 0"
            @changeChecked="changeChecked(m.id, $event)"
            @edit="onEdit($event)"
            @deleted="onDeleted($event)"
          ></media-card-multi>
        </div>
      </template>
    </v-card>

    <new-edit-media
      @close="onMediaItemDialogClosed"
      :show-dialog="dialog"
      :edited-item="editedItem"
      :edited-index="editedIndex"
      :poisParentsChildrenRecs="linkedApartmentsIds"
    ></new-edit-media>

    <!--    <add-to-gallery-dialog-->
    <!--      v-if="showAddToGalleryDialog"-->
    <!--      :showDialog="showAddToGalleryDialog"-->
    <!--      @cancel="closeAddToGalleryDialog"-->
    <!--      @done="closeAddToGalleryDialog"-->
    <!--    ></add-to-gallery-dialog>-->

    <!--    <upload-dialog-->
    <!--      v-if="showUploadDialog"-->
    <!--      :showDialog="showUploadDialog"-->
    <!--      @cancel="closeUploadDialog"-->
    <!--      @done="closeUploadDialog"-->
    <!--    ></upload-dialog>-->
  </v-card>
</template>

<script>
import Enums from '../helpers/Enums'
import BuildingService from '@/services/BuildingService'
import ApartmentService from '@/services/ApartmentService'
import ParcelService from '@/services/ParcelService'
import MediaCardMulti from '../components/MediaCards/MediaCardMulti'
import MediaCardDescriptionGhost from '../components/MediaCards/MediaCardDescriptionGhost'
import MediaCardPoiTitleGhost from '../components/MediaCards/MediaCardPoiTitleGhost'
import MediaCardImageGhost from '../components/MediaCards/MediaCardImageGhost'
import NewEditMedia from '../components/NewEditMedia'
import AddToGalleryDialog from '../components/AddToGalleryDialog'
import { mapState, mapGetters } from 'vuex'
import MasterplanService from '../services/MasterplanService'
import { link } from 'fs'
import draggable from 'vuedraggable'

export default {
  components: {
    NewEditMedia,
    MediaCardMulti,
    MediaCardDescriptionGhost,
    MediaCardPoiTitleGhost,
    MediaCardImageGhost,
    draggable
  },
  data() {
    return {
      checkedMedia: [],
      titleIds: [22, 1],
      descriptionIds: [4, 11],
      imageIds: [3, 2, 21],
      poiGalleryImagesLocal: [],
      isDraggingGallery: false,
      poiGalleryDirty: false,
      poiGallerySaving: false,
      gridViewMedia: true,
      fileTypes: ['all', 'audio', 'video', 'image', 'data', 'text', 'gallery'],
      creatingNewMediaGallery: false,
      editedItem: {
        name: 'New Media Item',
        mediaTypeId: 0,
        textualContent: '',
        mediaData: {},
        path: '',
        url: '',
        parentGalleryId: 0,
        poiId: 0,
        langId: this.getDefaultLangId
      },
      defaultItem: {
        name: 'New Media Item',
        mediaTypeId: 0,
        textualContent: '',
        mediaData: {},
        path: '',
        url: '',
        parentGalleryId: 0,
        poiId: 0,
        langId: this.getDefaultLangId
      },
      dialog: false,
      showNewEditMediaDialog: false,
      editedIndex: -1,
      //media: [],
      showAddToGalleryDialog: false,
      children: [],
      linkedApartmentsIds: [],
      searchParams: {
        langId: 0,
        search: null,
        mediaTypeId: 0,
        orderBy: 'updatedAt',
        orderDirection: 'desc'
      },
      searchKeyword: '',
      filterLangId: 0,
      searchTimer: null,
      infiniteScrollDummyVisible: false,
      showGhostItems: {
        title: false,
        description: false,
        titleImage: false
      }
    }
  },
  computed: {
    ...mapState('MediaStore', [
      'selectedGallery',
      'mediaPageSize',
      'mediaContext'
    ]),
    ...mapState('ProjectStore', ['selectedProject']),
    ...mapState('PoiStore', ['selectedPoi']),
    ...mapGetters('ProjectStore', ['getDefaultLangId']),
    ...mapGetters('ProjectStore', {
      showProjectTitleMediaItemGhost: 'showTitleMediaItemGhost'
    }),
    ...mapGetters('ProjectStore', {
      showProjectDescriptionMediaItemGhost: 'showDescriptionMediaItemGhost'
    }),
    ...mapGetters('ProjectStore', {
      showProjectTitleImageMediaItemGhost: 'showTitleImageMediaItemGhost'
    }),
    ...mapGetters('PoiStore', [
      'showTitleMediaItemGhost',
      'showDescriptionMediaItemGhost',
      'showTitleImageMediaItemGhost'
    ]),
    crossSectionMedia() {
      return this.media
        .filter(m => m.mediaData && m.mediaData.isCrossSection)
        .sort((a, b) => a.mediaData.floorIndex - b.mediaData.floorIndex)
    },
    regularMedia() {
      return this.media.filter(
        m =>
          !(m.mediaData && m.mediaData.isCrossSection) &&
          !(
            this.mediaContext === 'poi' &&
            m.mediaTypeId === Enums.MediaType.poi_image
          )
      )
    },
    // Pulled out of regularMedia into their own orderable section, same
    // pattern as crossSectionMedia above. Sorted by PoiContent.sortOrder
    // (the through-table column added for gallery ordering); items without
    // it yet (pre-migration data, or the null default) sort last.
    poiGalleryImages() {
      if (this.mediaContext !== 'poi') return []
      return this.media
        .filter(m => m.mediaTypeId === Enums.MediaType.poi_image)
        .slice()
        .sort((a, b) => {
          const aOrder = (a.PoiContent && a.PoiContent.sortOrder) || Infinity
          const bOrder = (b.PoiContent && b.PoiContent.sortOrder) || Infinity
          return aOrder - bOrder
        })
    },
    isBuildingMediaContext() {
      return (
        this.mediaContext === 'poi' &&
        this.$store.state.PoiStore.poiContext === 'building'
      )
    },
    showCrossSections() {
      return this.isBuildingMediaContext && this.crossSectionMedia.length > 0
    },
    getActiveLang() {
      if (this.searchParams.langId === 0) {
        return this.getDefaultLangId
      }
      return this.searchParams.langId
    },
    checkSelectedImages() {
      let res = true
      let selectedMedia = this.media.filter(m =>
        this.checkedMedia.includes(m.id)
      )

      if (
        selectedMedia.length === 1 &&
        (selectedMedia[0].mediaTypeId === Enums.MediaType.poi_image ||
          selectedMedia[0].mediaTypeId === Enums.MediaType.project_title_image)
      ) {
        res = false
      }
      return res
    },
    isCheckedMedia() {
      return id => {
        return this.checkedMedia.includes(id)
      }
    },
    supportedLangs() {
      let arr = [
        {
          id: 0,
          name: 'All'
        }
      ]
      Object.entries(Enums.lang).forEach(([key, value]) => {
        if (this.projectLangs.includes(value.id)) {
          arr.push(value)
        }
      })
      return arr
    },
    projectLangs() {
      if (
        this.$store.state.ProjectStore.projectConfig &&
        this.$store.state.ProjectStore.projectConfig.length > 0
      ) {
        return this.$store.state.ProjectStore.projectConfig[
          this.$store.state.ProjectStore.projectConfig.length - 1
        ].mediaData.selectedLangs
      }
      return []
    }
  },
  watch: {
    searchParams: {
      deep: true,
      async handler() {
        await this.$store.dispatch('MediaStore/fetchMedia', this.searchParams)
      }
    },
    poiGalleryImages: {
      immediate: true,
      handler(val) {
        // Once the user has made an unsaved edit, poiGalleryImagesLocal is
        // authoritative until they Save or Discard — an unrelated media
        // refetch (search, filters, infinite scroll) elsewhere on this page
        // shouldn't silently drop pending gallery changes.
        if (!this.poiGalleryDirty) {
          this.poiGalleryImagesLocal = val.map(this.cloneGalleryItem)
        }
      }
    },
    editedItem: function() {
      //this.filterLinkedApartments();
    },
    searchKeyword: function(val) {
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(async () => {
        this.infiniteScrollDummyVisible = false
        await this.$store.dispatch('MediaStore/resetMedia')
        await this.$store.dispatch('MediaStore/resetPaging')
        this.searchParams = Object.assign({}, this.searchParams, {
          search: val
        })
      }, 500) // 1 sec delay
    },
    filterLangId: async function(val) {
      this.infiniteScrollDummyVisible = false
      await this.$store.dispatch('MediaStore/resetMedia')
      await this.$store.dispatch('MediaStore/resetPaging')
      this.searchParams = Object.assign({}, this.searchParams, {
        langId: val
      })
    },
    isVisible: async function(newValue) {
      if (newValue) {
        await this.$store.dispatch('MediaStore/resetMedia')
        await this.$store.dispatch('MediaStore/resetPaging')
        if (!this.infiniteScrollDummyVisible) await this.getData()
      }
    }
  },
  mounted: function() {},
  updated: function() {
    this.$nextTick(function() {
      if (this.media.length >= this.mediaPageSize) {
        this.infiniteScrollDummyVisible = true // needed to prevent false positive when first rendering the list before fetch data
      }
    })
  },
  props: {
    isVisible: Boolean,
    context: String,
    media: Array
  },
  created: async function() {
    await this.getData()

    this.mediaTypesEnum = Enums.MediaType
  },
  methods: {
    filterLinkedApartments() {
      let nestedIds = []
      let stanovi = []
      let masterplans = this.$store.state.MasterplanStore
        .selectedMasterplansNestedMasterplans
      for (let i = 0; i < masterplans.length; i++) {
        nestedIds.push(masterplans[i].id)
        masterplans[i].type = 'masterplan'
        stanovi.push(masterplans[i])
      }

      let communities = this.$store.state.MasterplanStore
        .selectedMasterplansNestedMasterplansCommunities
      for (let i = 0; i < communities.length; i++) {
        nestedIds.push(communities[i].id)
        communities[i].type = 'masterplan'
        stanovi.push(communities[i])
      }

      let buildings = this.$store.state.BuildingStore.buildings
      for (let i = 0; i < buildings.length; i++) {
        nestedIds.push(buildings[i].id)
        buildings[i].type = 'building'
        stanovi.push(buildings[i])
      }
      let apartments = this.$store.state.ApartmentStore.apartments
      for (let i = 0; i < apartments.length; i++) {
        nestedIds.push(apartments[i].id)
        apartments[i].type = 'apartment'
        stanovi.push(apartments[i])
      }

      if (this.$store.state.ProjectStore.selectedProject.isParcelProject) {
        let parcels = this.$store.state.ParcelStore.parcels
        for (let i = 0; i < parcels.length; i++) {
          nestedIds.push(parcels[i].id)
          parcels[i].type = 'parcel'
          stanovi.push(parcels[i])
        }
      }

      let linkedIds = []
      const polygons = this.editedItem.mediaData.polygons
      let children = []
      const self = this
      if (polygons) {
        const result = polygons.find(ele =>
          ele.find(e => e.hasOwnProperty('children'))
        )
        children = result[1].children
        for (let i = 0; i < children.length; i++) {
          linkedIds.push(children[i][1].data.linkedRecord.id)
        }
        stanovi = stanovi.filter(function(ele) {
          return !linkedIds.includes(ele.id)
        })
        for (let i = 0; i < stanovi.length; i++) {
          self.$store.dispatch('MediaStore/saveLinkedPoi', stanovi[i])
        }
      } else {
        for (let i = 0; i < stanovi.length; i++) {
          self.$store.dispatch('MediaStore/saveLinkedPoi', stanovi[i])
        }
      }

      this.linkedApartmentsIds = stanovi
    },
    async setLinkedAssets(linkedPois) {
      await this.$store.dispatch('MediaStore/setLinkedAssetsForDzi', linkedPois)
    },
    async setNotLinkedAssets(notLinkedPois) {
      await this.$store.dispatch(
        'MediaStore/setNotLinkedAssetsForDzi',
        notLinkedPois
      )
    },
    async setNotLinkedPois(notLinkedPois) {
      await this.$store.dispatch('MediaStore/saveNotLinkedPois', notLinkedPois)
    },
    setLinkedUnlinkedPoisForDzi() {
      this.setNotLinkedAssets(this.children)
      let poisForAsset = this.$store.state.PoiStore.pois
      let savedPoiLinks = this.$store.state.MediaStore.selectedMediaItem
        .mediaData.pois
      if (savedPoiLinks) {
        this.$store.dispatch('MediaStore/saveLinkedPoi', savedPoiLinks)
      }
      let res = []
      if (Array.isArray(poisForAsset) && Array.isArray(savedPoiLinks)) {
        res = poisForAsset.filter(function(poiForAsset) {
          return (
            savedPoiLinks.filter(function(savedPoiLink) {
              return savedPoiLink.id == poiForAsset.id
            }).length == 0
          )
        })
      } else {
        this.setNotLinkedPois(poisForAsset)
      }

      this.setNotLinkedPois(res)
      let polyLenght = 0
      let mediaDzi = []
      let qwe = []
      let children2 = []
      //let poisForAsset = this.$store.dispatch('MediaManagerStore/getMediaPois', this.$store.state.MediaStore.media[0].id)
      if (
        this.$store.state.MediaStore.media[0].mediaData.hasOwnProperty(
          'polygons'
        )
      ) {
        polyLenght = this.$store.state.MediaStore.media[0].mediaData.polygons
          .length
        mediaDzi = this.$store.state.MediaStore.media[0].mediaData.polygons[
          polyLenght - 1
        ][1]
        qwe = [...this.$store.state.MediaStore.media[0].mediaData.polygons]
        ;({ children: children2 } = qwe[qwe.length - 1][1])
        //let linkedPoisIds = []
      }
      let {
        children: linkedPois,
        mediaData: mediaData,
        polygons: polygons
      } = mediaDzi
    },
    deleteMediaGroupDialog() {
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete group of media items',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Delete',
        ok: () => {
          this.deleteMediaGroup()
        },
        cancelText: 'Cancel'
      })
    },
    async checkRequiredMediaItemsExist() {
      if (this.mediaContext === 'poi') {
        await this.$store.dispatch('PoiStore/checkPoiHasRequiredMediaItems')
      } else if (this.mediaContext === 'project') {
        await this.$store.dispatch(
          'ProjectStore/checkProjectHasRequiredMediaItems'
        )
      }
    },
    async deleteMediaGroup() {
      await this.$store.dispatch('MediaStore/deleteMedia', this.checkedMedia)
      await this.checkRequiredMediaItemsExist()

      this.checkedMedia = []
    },
    changeChecked(id, e) {
      if (this.checkedMedia.includes(id)) {
        for (var i = 0; i < this.checkedMedia.length; i++) {
          if (this.checkedMedia[i] === id) {
            this.checkedMedia.splice(i, 1)
          }
        }
      } else {
        this.checkedMedia.push(id)
      }
    },
    async refreshGalleryMedia() {
      this.infiniteScrollDummyVisible = false
      await this.$store.dispatch('MediaStore/resetMedia')
      await this.$store.dispatch('MediaStore/resetPaging')
      await this.$store.dispatch('MediaStore/fetchMedia', this.searchParams)
    },
    // Fresh object (and fresh nested PoiContent object) per item, every
    // time the gallery's local state changes for any reason — that's what
    // makes each card's own "media" prop watcher fire and pull the
    // possibly-just-edited sortOrder back into its text field. Mutating
    // sortOrder in place wouldn't do that: Vue 2 tracks the property
    // change fine, but the card's own typed-input buffer only resyncs on
    // prop *reference* change, not on a nested mutation of the same object.
    cloneGalleryItem(m) {
      return Object.assign({}, m, {
        PoiContent: Object.assign({}, m.PoiContent)
      })
    },
    refreshGalleryLocalRefs() {
      this.poiGalleryImagesLocal = this.poiGalleryImagesLocal.map(
        this.cloneGalleryItem
      )
    },
    onGalleryDragEnd() {
      this.isDraggingGallery = false
      this.poiGalleryImagesLocal.forEach((m, i) => {
        m.PoiContent.sortOrder = i + 1
      })
      this.poiGalleryDirty = true
      this.refreshGalleryLocalRefs()
    },
    async onGalleryIndexCommit(media, newOrder) {
      let conflict = this.poiGalleryImagesLocal.find(
        m => m.id !== media.id && m.PoiContent.sortOrder === newOrder
      )
      if (conflict) {
        try {
          await this.$confirm({
            title: 'Position already used',
            text: `Position ${newOrder} is already used by "${
              conflict.name
            }". Swap positions?`,
            acceptText: 'SWAP',
            cancelText: 'CANCEL'
          })
          let previous = media.PoiContent.sortOrder
          conflict.PoiContent.sortOrder = previous
          media.PoiContent.sortOrder = newOrder
          this.poiGalleryDirty = true
        } catch (e) {
          // Cancelled — nothing changes; refreshGalleryLocalRefs below
          // still runs so the card's stale typed value snaps back.
        }
      } else {
        media.PoiContent.sortOrder = newOrder
        this.poiGalleryDirty = true
      }
      this.refreshGalleryLocalRefs()
    },
    discardGallery() {
      this.poiGalleryDirty = false
      this.poiGalleryImagesLocal = this.poiGalleryImages.map(
        this.cloneGalleryItem
      )
    },
    async saveGallery() {
      this.poiGallerySaving = true
      let items = this.poiGalleryImagesLocal.map(m => ({
        mediaId: m.id,
        sortOrder: m.PoiContent.sortOrder
      }))
      let ok = await this.$store.dispatch('PoiStore/saveGallerySortOrders', {
        poiId: this.selectedPoi.id,
        items
      })
      if (ok) {
        this.poiGalleryDirty = false
        await this.refreshGalleryMedia()
      }
      this.poiGallerySaving = false
    },
    // Called by the parent Explore view's beforeRouteLeave / tab-switch
    // guard (see mixins/MediaGalleryLeaveGuard.js) before it lets the user
    // navigate away or switch off this tab. Always resolves — there's no
    // "stay here" option, just a choice of whether to persist first.
    async promptSaveDiscardIfDirty() {
      if (!this.poiGalleryDirty) return
      try {
        await this.$confirm({
          title: 'Unsaved gallery changes',
          text: 'Save your reordering before leaving?',
          acceptText: 'SAVE',
          cancelText: "DON'T SAVE"
        })
        await this.saveGallery()
      } catch (e) {
        this.discardGallery()
      }
    },
    async getData() {
      if (this.mediaContext === 'poi') {
        // get selected poi id

        let poi = await this.$store.state.PoiStore.selectedPoi

        // find pois parent

        await this.$store.dispatch('PoiStore/fetchPoiTypes')

        let poiType = await this.$store.state.PoiStore.poiTypes.find(
          el => el.typeId === poi.poiTypeId
        )
        let parent = await this.$store.dispatch(
          'PoiStore/getPoisParent',
          poi.id
        )
        //based on type, get pois parent record children available for linking

        switch (poiType.parentType) {
          case 'masterplan':
            {
              // await this.$store.dispatch(
              //   'MasterplanStore/setSelectedMasterplan',
              //   parent.data.id
              // )
              await this.$store.dispatch(
                'BuildingStore/fetchBuildings',
                poi.parentId
              )

              let respChildrenMasterplans = await MasterplanService.getNestedMasterplans(
                poi.parentId
              )
              let childrenMasterplans = respChildrenMasterplans.data

              let respChildrenBuildings = await MasterplanService.getBuildingsForMasterplan(
                poi.parentId
              )
              let childrenBuildings = respChildrenBuildings.data

              childrenMasterplans.forEach(element => {
                element = Object.assign(element, { type: 'masterplan' })
              })
              childrenBuildings.forEach(element => {
                element = Object.assign(element, { type: 'building' })
              })
              this.children = childrenMasterplans.concat(childrenBuildings)

              // In a parcel project the masterplan DZI links to parcels (plot
              // polygons) alongside buildings/nested masterplans.
              if (
                this.$store.state.ProjectStore.selectedProject.isParcelProject
              ) {
                let respChildrenParcels = await ParcelService.getParcelsForMasterplan(
                  poi.parentId
                )
                let childrenParcels = respChildrenParcels.data
                childrenParcels.forEach(element => {
                  element = Object.assign(element, { type: 'parcel' })
                })
                this.children = this.children.concat(childrenParcels)
              }
            }
            break
          case 'building':
            {
              // await this.$store.dispatch(
              //   'BuildingStore/setSelectedBuilding',
              //   parent.data.id
              // )
              await this.$store.dispatch('ApartmentStore/fetchApartments')
              this.children = this.$store.state.ApartmentStore.apartments
              this.children.forEach(element => {
                element = Object.assign(element, { type: 'apartment' })
              })
            }
            break
        }
        await this.$store.dispatch(
          'MediaStore/fetchMediaTypes',
          poiType.parentType
        )
        //await this.$store.dispatch('MediaStore/resetMedia')
        await this.$store.dispatch('MediaStore/fetchMedia', this.searchParams)
      } else if (this.mediaContext === 'project') {
        await this.$store.dispatch('MediaStore/fetchMediaTypes', 'project')
        await this.$store.dispatch('MediaStore/fetchMedia', this.searchParams)
      }
    },
    openMediaItemDialog(type) {
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
      if (this.mediaContext === 'poi') {
        switch (type) {
          case 'title-ghost': {
            this.editedItem.mediaTypeId = Enums.MediaType.poi_title
            break
          }
          case 'description-ghost': {
            this.editedItem.mediaTypeId = Enums.MediaType.description
            break
          }
          case 'image-ghost': {
            this.editedItem.mediaTypeId = Enums.MediaType.poi_image
            break
          }
        }
      } else if (this.mediaContext === 'project') {
        switch (type) {
          case 'title-ghost': {
            this.editedItem.mediaTypeId = Enums.MediaType.project_title
            break
          }
          case 'description-ghost': {
            this.editedItem.mediaTypeId =
              Enums.MediaType.project_text_description
            break
          }
          case 'image-ghost': {
            this.editedItem.mediaTypeId = Enums.MediaType.project_title_image
            break
          }
        }
      }

      this.editedItem.langId = this.getActiveLang
      this.dialog = true
    },
    addCrossSection() {
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem, {
        mediaTypeId: Enums.MediaType.poi_image_dzi,
        mediaData: { isCrossSection: true }
      })
      this.editedItem.langId = this.getActiveLang
      this.dialog = true
    },
    async onMediaItemDialogClosed() {
      this.$store.dispatch('MediaStore/resetLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedPois')
      this.dialog = false
      this.editedIndex = -1
      this.infiniteScrollDummyVisible = false
      await this.$store.dispatch('MediaStore/resetMedia')
      await this.$store.dispatch('MediaStore/resetPaging')
      await this.checkRequiredMediaItemsExist()
      await this.$store.dispatch('MediaStore/fetchMedia', this.searchParams)
    },

    editItem(item) {
      this.editedIndex = item.id
      this.editedItem = Object.assign({}, item)
      //this.editedItem.mediaData = JSON.stringify(this.editedItem.mediaData);
      this.dialog = true
      //this.showParentOptions = true;
      //this.filterLinkedApartments()
    },

    onEdit(e) {
      this.$store.dispatch('MediaStore/resetLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedPois')
      this.$store.dispatch('MediaStore/resetNotLinkedAssetsForDzi')

      if (e) {
        this.$store
          .dispatch('MediaStore/setSelectedMediaItem', e, {
            root: true
          })
          .then(() => {
            this.setLinkedUnlinkedPoisForDzi()
            this.editItem(this.$store.state.MediaStore.selectedMediaItem)
          })
      }
      // this.setLinkedUnlinkedPoisForDzi();
    },
    async onDeleted(id, media) {
      if (
        this.$store.state.UserStore.user.id !== 1 &&
        media.mediaTypeId === 21
      ) {
        await this.$confirm({
          title: "! This media can't be deleted !",
          text:
            'If you delete an image or a dzi, there is a chance that the app wont work properly, please consult support if you have any questions.',
          acceptText: 'Accept'
        })
      } else if (id) {
        await this.$confirm({
          title: 'Delete',
          text: 'Are you sure?',
          acceptText: 'DELETE',
          cancelText: 'CANCEL'
        })
        await this.$store.dispatch('MediaStore/deleteMedia', [id])
        await this.checkRequiredMediaItemsExist()
      }
    },
    // async createNewGallery() {
    //   let gallery = Object.assign({}, this.defaultItem)
    //   gallery.name = 'New Gallery'
    //   gallery.mediaTypeId = Enums.MediaType.media_gallery
    //
    //   let newGallery = await this.$store.dispatch(
    //     'MediaStore/createMedia',
    //     gallery
    //   )
    //   this.getData()
    // },
    // openAddToGalleryDialog: async function() {
    //   if (!this.showAddToGalleryDialog) {
    //     await this.$store.dispatch(
    //       'MediaStore/getSelectedMediaItemParentGalleries'
    //     )
    //     this.showAddToGalleryDialog = true
    //   }
    // },
    // closeAddToGalleryDialog: function() {
    //   this.showAddToGalleryDialog = false
    //   this.getData()
    // },
    // getPolygonsLinkData() {},
    // async exitGallery() {
    //   await this.$store.dispatch('MediaStore/unsetSelectedGallery')
    // },
    async setTitleImage() {
      let currentTitleImage

      let res = true
      let selectedMedia = this.getSelectedMedia()

      let mediaId = selectedMedia[0].id

      if (
        selectedMedia.length > 1 ||
        ![
          Enums.MediaType.poi_image,
          Enums.MediaType.project_title_image
        ].includes(selectedMedia[0].mediaTypeId)
      )
        return

      if (this.mediaContext === 'project') {
        currentTitleImage = await this.$store.dispatch(
          'ProjectStore/getTitleImage',
          selectedMedia[0].langId
        )
        await this.$store.dispatch('ProjectStore/setTitleImage', {
          projectId: this.selectedProject.id,
          mediaId
        })
      } else if (this.mediaContext === 'poi') {
        currentTitleImage = await this.$store.dispatch(
          'PoiStore/getTitleImage',
          selectedMedia[0].langId
        )
        await this.$store.dispatch('PoiStore/setTitleImage', {
          poiId: this.selectedPoi.id,
          mediaId
        })
      }
      await this.$store.dispatch('MediaStore/refreshMedia', mediaId)
      if (currentTitleImage.length > 0) {
        await this.$store.dispatch(
          'MediaStore/refreshMedia',
          currentTitleImage[0].id
        )
      }

      await this.checkRequiredMediaItemsExist()
    },
    getSelectedMedia() {
      return this.media.filter(m => this.checkedMedia.includes(m.id))
    },
    handleItemSelected(active, toggle) {
      toggle()
    },
    onIntersect: function(entries, observer, isIntersecting) {
      this.infiniteScrollDummyVisible = false
      if (isIntersecting) {
        //this.searchParams.pageNumber++
        this.getData()
      }
    },
    showGhost(ghostType) {
      let result = false
      if (this.mediaContext === 'poi') {
        switch (ghostType) {
          case 'title-media-item': {
            result = this.showTitleMediaItemGhost
            break
          }
          case 'description-media-item': {
            result = this.showDescriptionMediaItemGhost
            break
          }
          case 'title-image-media-item': {
            result = this.showTitleImageMediaItemGhost
            break
          }
        }
      } else if (this.mediaContext === 'project') {
        switch (ghostType) {
          case 'title-media-item': {
            result = this.showProjectTitleMediaItemGhost
            break
          }
          case 'description-media-item': {
            result = this.showProjectDescriptionMediaItemGhost
            break
          }
          case 'title-image-media-item': {
            result = this.showProjectTitleImageMediaItemGhost
            break
          }
        }
      }
      return result
    }
  },
  async beforeRouteLeave(to, from, next) {
    // if (to.path !== '/gallery') {
    //   this.$store.dispatch('MediaStore/unsetSelectedGallery')
    //   this.getData()
    // }
    next()
  }
}
</script>

<style scoped>
.gallery-drag-ghost {
  opacity: 0.35;
  background: rgba(33, 150, 243, 0.1);
  border-radius: 4px;
}
</style>
